import { AdminGrowthInvestment } from "./AdminGrowthInvestment"
import { AdminGrowthInvestmentMonthlyPoint } from "./AdminGrowthInvestmentMonthlyPoint"
import { AdminGrowthInvestmentPerformance } from "./AdminGrowthInvestmentPerformance"
import { AdminGrowthInvestmentSummary } from "./AdminGrowthInvestmentSummary"

export class AdminGrowthInvestmentDashboard {
  summary: AdminGrowthInvestmentSummary

  investments: AdminGrowthInvestment[]

  monthlySeries: AdminGrowthInvestmentMonthlyPoint[]

  campaigns: AdminGrowthInvestmentPerformance[]

  channels: AdminGrowthInvestmentPerformance[]

  origins: AdminGrowthInvestmentPerformance[]

  constructor(data: Partial<AdminGrowthInvestmentDashboard> = {}) {
    this.summary = new AdminGrowthInvestmentSummary(data.summary)

    this.investments = data.investments?.map((item) => new AdminGrowthInvestment(item)) ?? []

    this.monthlySeries = data.monthlySeries?.map((item) => new AdminGrowthInvestmentMonthlyPoint(item)) ?? []

    this.campaigns = data.campaigns?.map((item) => new AdminGrowthInvestmentPerformance(item)) ?? []

    this.channels = data.channels?.map((item) => new AdminGrowthInvestmentPerformance(item)) ?? []

    this.origins = data.origins?.map((item) => new AdminGrowthInvestmentPerformance(item)) ?? []
  }
}
